import { render, staticRenderFns } from "./editNewCustomer.vue?vue&type=template&id=873aa468&scoped=true&"
import script from "./editNewCustomer.vue?vue&type=script&lang=js&"
export * from "./editNewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./editNewCustomer.vue?vue&type=style&index=0&id=873aa468&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873aa468",
  null
  
)

export default component.exports